import { render } from "./FairMines.vue?vue&type=template&id=3035a534&scoped=true"
import script from "./FairMines.vue?vue&type=script&lang=js"
export * from "./FairMines.vue?vue&type=script&lang=js"

import "./FairMines.vue?vue&type=style&index=0&id=3035a534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3035a534"]])

export default __exports__